import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from '../../utils/noop';

import '../CustomIcon/styles.css';
import './styles.css';

class Card extends Component {
  constructor(props) {
    super(props);

    this.state = { flipped: false };
    this.handleFlip = this.handleFlip.bind(this);
    this.renderToggleIcon = this.renderToggleIcon.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.flipped && this.props.updating && !nextProps.updating) {
      this.setState({ flipped: false });
    }
  }

  handleFlip(e) {
    const { flippedCallback, toggledCallback } = this.props;

    e.preventDefault();

    this.setState({ flipped: !this.state.flipped });

    if (toggledCallback) {
      toggledCallback(this.state.flipped);
    }

    if (!this.state.flipped && flippedCallback) {
      flippedCallback();
    }
  }

  renderToggleIcon() {
    const { renderToggleIcon } = this.props;
    const { flipped } = this.state;

    if (renderToggleIcon) {
      return renderToggleIcon(flipped);
    }

    return (
      <i
        style={{ lineHeight: '1', fontSize: '16px', marginTop: '1px' }}
        className={`icon-budicon-${flipped ? 471 : 330}`}
      />
    );
  }

  render() {
    const { header, children, fixHeight, disabled } = this.props;
    const { flipped } = this.state;

    let double = false;
    let front = children;
    let back = null;
    if (Array.isArray(children)) {
      front = children[0];
      back = children[1];
      double = !!(front && back);
    }

    return (
      <div className="card__outer" style={{ height: fixHeight || 'auto' }}>
        {(header || double || disabled) && (
          <div
            className={classNames(
              'card__header',
              {'card__header--disabled': disabled}
            )}
          >
            {disabled && (
              <span className="card__toggle">
                {this.renderToggleIcon()}
              </span>
            )}
            {double && (
              <a className="card__toggle" href="#" onClick={this.handleFlip}>
                {this.renderToggleIcon()}
              </a>
            )}
            {typeof header === 'string' ? (
              <h4 className="card__title">{header}</h4>
            ) : (
              header
            )}
          </div>
        )}
        <div
          className={classNames(
            'card__body',
            { 'card__body--flipped': flipped },
            { 'card__body--disabled': disabled },
            { 'card__body--fix': fixHeight }
          )}
        >
          {double ? (
            <div className="card__backface">
              <div className={classNames('card__front', {'card__body__face--flipped': flipped})}>{front}</div>
              <div className={classNames('card__back', {'card__body__face--flipped': !flipped})}>{back}</div>
            </div>
          ) : (
            <div className="card__front">{front}</div>
          )}
        </div>
      </div>
    );
  }
}

Card.propTypes = {
  renderToggleIcon: PropTypes.func,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  updating: PropTypes.bool,
  flippedCallback: PropTypes.func,
  toggledCallback: PropTypes.func,
  fixHeight: PropTypes.number,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

Card.defaultProps = {
  flippedCallback: noop,
  toggledCallback: noop
};

export default Card;
